import React, { useEffect } from 'react';
import { retainTheme } from './themeStore';

/**
 * Mount once, above the app (index.tsx). Applies the stored choice to <html> and keeps System in step with the device on
 * every page, including the ones with no switch (sign-in, settings). The switch itself works without it.
 */
export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => retainTheme(), []);
  return <>{children}</>;
}
